import React from 'react';
import styled from '@emotion/styled';
import { floatAnimations } from './animations';
import { BubbleData } from './utils';

const StyledBubble = styled.div<{
  $size: number;
  $left: number;
  $bottom: number;
  $delay: number;
  $duration: number;
  $animIndex: number;
  $hue: number;
}>`
  position: absolute;
  left: ${({ $left }) => $left}%;
  bottom: ${({ $bottom }) => $bottom}%;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 50%;
  background: ${({ $hue }) => `radial-gradient(circle at 30% 30%, 
    hsla(${$hue}, 70%, 65%, 0.7), 
    hsla(${$hue + 20}, 50%, 40%, 0.4))`};
  animation: ${({ $animIndex }) => floatAnimations[$animIndex % floatAnimations.length]}
    ${({ $duration }) => $duration}s ease-in-out infinite;
  animation-delay: ${({ $delay }) => $delay}s;
  filter: blur(2px);
  will-change: transform, opacity;
  opacity: 0.6;
`;

type BubbleProps = {
  data: BubbleData;
};

export const Bubble: React.FC<BubbleProps> = ({ data }) => (
  <StyledBubble
    $size={data.size}
    $left={data.left}
    $bottom={data.bottom}
    $delay={data.delay}
    $duration={data.duration}
    $animIndex={data.animIndex}
    $hue={data.hue}
  />
);
